module.exports = __webpack_public_path__ + "static/media/background-mobile-two.f76d7a5b.png";